<template>
  <div>
    <h2>Group Settings</h2>
    <b-spinner v-if="!group" />
    <div v-else>
      <b-card
        title="Current Semester"
        sub-title="Set the current active semester for a group."
      >
        <!-- TODO: Add custom semester select component to hide previous semesters we don't care about. -->
        <b-select
          :options="options"
          v-model="settings.current_semester_id"
        ></b-select>
        <b-button class="mt-2" @click="saveCurrentSemester()">
          Save Current Semester
        </b-button>
        <!-- <b-radio-group :options="[{ text: 'Registration open to everyone', value: 'open'}, { text: 'Registration open for new registrations only', value: 'open-new'}]"></b-radio-group> -->
      </b-card>
      <b-card
        class="mt-2"
        title="Email Password Reset Enabled"
        sub-title="Allow/Disable email password reset for the group."
      >
        <!-- TODO: Add custom semester select component to hide previous semesters we don't care about. -->
        <b-checkbox v-model="settings.is_password_reset_email_enabled"
          >Forgot Password Email Enabled</b-checkbox
        >
        <b-button class="mt-2" @click="saveSettings()">
          Save Setting
        </b-button>
        <!-- <b-radio-group :options="[{ text: 'Registration open to everyone', value: 'open'}, { text: 'Registration open for new registrations only', value: 'open-new'}]"></b-radio-group> -->
      </b-card>
      <b-card
        class="mt-2"
        title="Select Band Group"
        sub-title="Select Band to send group notifications."
      >
        <!-- TODO: Add custom semester select component to hide previous semesters we don't care about. -->
        <b-select :options="bands" v-model="settings.band_key"></b-select>
        <b-button class="mt-2" @click="saveSettings()">
          Save Setting
        </b-button>
        <!-- <b-radio-group :options="[{ text: 'Registration open to everyone', value: 'open'}, { text: 'Registration open for new registrations only', value: 'open-new'}]"></b-radio-group> -->
      </b-card>
      <b-card
        title="Membership Form Settings"
        sub-title="Settings for membership form - Terms and Conditions and Fees"
        class="mt-3"
      >
        <router-link :to="{ name: 'edit_membership_form_settings' }"
          >Membership Form Settings</router-link
        >
      </b-card>
      <!--
            <b-card
                title="Teacher Settings"
                sub-title="Settings for teachers."
                class="mt-3"
            >
                <b-radio-group :options="[{ text: 'Registration open to everyone', value: 'open'}, { text: 'Registration open for new registrations only', value: 'open-new'}]"></b-radio-group>
            </b-card>
            -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      settings: {
        registration_open: false,
        band_key: null,
      },
      options: [],
      bands: [],
    };
  },
  computed: mapState(["group"]),
  mounted() {
    this.settings.current_semester_id = this.group
      ? this.group.current_semester_id
      : null;
    this.settings.is_password_reset_email_enabled = this.group
      ? this.group.is_password_reset_email_enabled
      : false;
    this.settings.band_key = this.group ? this.group.band_key : null;
    this.getSemesters();
    this.getBands();
  },
  methods: {
    async getSemesters() {
      const {
        data: { semesters },
      } = await this.$api.get("/api/admin/semesters/list");

      if (semesters) {
        this.options = semesters.map(({ label: text, id: value }) => {
          return { text, value };
        });
      }
    },
    async saveCurrentSemester() {
      const { data } = await this.$api.post(
        "/api/group/admin/set-current-semester",
        {
          semester_id: this.settings.current_semester_id,
        },
      );

      this.$bvToast.toast(data.message, {
        title: data.success ? "Success" : "Error",
        variant: data.success ? "success" : "danger",
        autoHideDelay: 5000,
        appendToast: true,
      });

      if (data.semester) {
        this.$store.commit("setSemester", data.semester);
      }
    },
    async getBands() {
      const {
        data: {
          bands: { result_data },
        },
      } = await this.$api.get("/api/admin/bands");

      if (result_data) {
        this.bands = result_data.bands.map(
          ({ name: text, band_key: value }) => {
            return { text, value };
          },
        );
      }
    },
    async saveSettings() {
      const { data } = await this.$api.put("/api/group/admin/settings", {
        is_password_reset_email_enabled: this.settings
          .is_password_reset_email_enabled,
        band_key: this.settings.band_key,
      });

      this.$bvToast.toast(data.message, {
        title: data.success ? "Success" : "Error",
        variant: data.success ? "success" : "danger",
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
  watch: {
    group(group) {
      this.settings.current_semester_id = group
        ? group.current_semester_id
        : null;
    },
  },
};
</script>
